import { SessionEvent } from '../Session/ISessionEvent';
import { UserArticleReadingStats } from '../Types/UserArticleReadingStats';
import { getApiInstance } from './Api';

export class ReadingDataApi {
  async processReadingEvents(events: SessionEvent[]) {
    const response = await getApiInstance().post(`/reading-data`, {
      events,
    });

    const data = response.data;
    return data;
  }

  async fetchArticleStats(articleId: string) {
    const response = await getApiInstance().get(
      `/reading-data/stats/article/${articleId}`,
    );
    const data = response.data;
    return this.mapUserArticleReadingStats(data);
  }

  private mapUserArticleReadingStats(
    userArticleReadingStats: any,
  ): UserArticleReadingStats {
    return {
      timeSpentReading: userArticleReadingStats.timeSpentReading,
      wordsRead: userArticleReadingStats.wordsRead,
      wordsPerMinuteRead: userArticleReadingStats.wordsPerMinuteRead,
    };
  }
}
